import type { FC } from 'react';
import cx from 'classnames';

import Content from 'Storybook/local/Content/Content';
import useFeatureToggle, { FEATURES } from 'Utilities/hooks/useFeatureToggle';

import { AiCompanion } from './AiCompanion';

import styles from './AiCompanion.module.scss';

export const AiCompanionContent: FC = () => {
	const isAiCompanionMultiConversationEnabled = useFeatureToggle(FEATURES.enableAiCompanionMultiConversation);

	return (
		<Content
			className={cx(styles.contentOverride, isAiCompanionMultiConversationEnabled && styles.multiConversationContent)}
		>
			<AiCompanion />
		</Content>
	);
};
